import { render } from "./change-phone.vue?vue&type=template&id=04016458&scoped=true"
import script from "./change-phone.vue?vue&type=script&lang=js"
export * from "./change-phone.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04016458"]])

export default __exports__